import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  courses: {}
}

export const getters = {}

export const mutations = {
  COURSE(state, request) {
    state.cached = request
  }
}

export const actions = {

  init({ state, dispatch }) {},

  fetchCourses(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/masters/courses/${query}`).then((response) => {
      const request = response.data
      context.commit('COURSE', request)
      return request
    })
  },
  fetchCoursesHome(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/masters/courses/courses_home/${query}`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchCourseOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/courses/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchCourseDetail(context, id) {
    return axios.get(`${serverUrl}/api/courses/${id}/`).then((response) => {
      return response.data
    })
  },


  createUpdateCourse(context, payload) {
    let promise = null
    if (payload.course_id){
      promise =  axios.put(`${serverUrl}/api/masters/courses/${payload.course_id}/`, payload)
    }else {
      promise =  axios.post(`${serverUrl}/api/masters/courses/`, payload)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  createCourseFile(context,payload){
    const promise =  axios.post(`${serverUrl}/api/masters/courses/${payload.course_id}/save_file/`, payload.formData,{headers: {'Content-Type': 'multipart/form-data'}})
    return promise
  },

  changeCourseState(context,payload){
    const promise =  axios.put(`${serverUrl}/api/masters/courses/${payload.course_id}/change_state/`, payload)
    return promise
  },

  getCourseFile(context,course_id){
    const promise =  axios.get(`${serverUrl}/api/masters/courses/${course_id}/get_file/`)
    return promise
  },

  deleteCourse(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  
  fetchCourseFiles(context, payload) {
    return axios.get(`${serverUrl}/api/courses/${payload.course_id}/files/`).then((response) => {
      return response.data
    })
  },

  deleteCourseFile(context, payload) {
    return axios.delete(`${serverUrl}/api/courses/${payload.course_id}/files/${payload.file_id}`).then((response) => {
      return response.data
    })
  },  

}
